
                  export default function (Component) {
                      Component.__source = "library/components/VabAppMain/index.vue"
                  }
              